<template>
    <article v-if="!isOverlay" class="cmp cmp-product-thumb cmp-product-thumb--grid"
        @mouseleave="loadNewImage(thumbForMain.firstImage.urlSecondPreview, '', '')">
        <div class="category-item__wrapper">

            <div class="category-item__image" v-if="catIdsReverseImage" ref="catImg">
                <!-- @mouseover="loadThumbs()" @mouseleave="loadThumbs('safari')" -->
                <a v-if="newUrl !== ''" :href="newUrl" class="d-block">
                    <img :class="'category-item__image-img-0'" :data-src="item.images.all[0].urlSecondPreview"
                        class="img-fluid category-item__image-img lazy-img"
                        src="https://bilder.weberbuero.de/frontend/images/shop/loading085.svg" :alt="item | itemName">
                </a>
                <a v-else :href="item | itemURL(false)" class="d-block">
                    <img :class="'category-item__image-img-0'" :data-src="item.images.all[0].urlSecondPreview"
                        class="img-fluid category-item__image-img lazy-img"
                        src="https://bilder.weberbuero.de/frontend/images/shop/loading085.svg" :alt="item | itemName">
                </a>
                <button class="btn category-item__quick-view" @click.prevent="openQuickView()">{{
        $translate("Weberbuero::Template.quickView") }}</button>
            </div>
            <div v-else class="category-item__image" ref="catImg">
                <!-- @mouseover="loadThumbs()" @mouseleave="loadThumbs('safari')" -->
                <a v-if="newUrl !== ''" :href="newUrl" class="d-block">
                    <img v-for="(image, index) in (images).slice(0, 1)" :data-src="image.urlSecondPreview"
                        :class="'category-item__image-img-0'" class="img-fluid category-item__image-img lazy-img"
                        src="https://bilder.weberbuero.de/frontend/images/shop/loading085.svg" :alt="item | itemName">
                </a>
                <a v-else :href="item | itemURL(false)" class="d-block">
                    <img v-for="(image, index) in (images).slice(0, 1)" :data-src="image.urlSecondPreview"
                        :class="'category-item__image-img-0'" class="img-fluid category-item__image-img lazy-img"
                        src="https://bilder.weberbuero.de/frontend/images/shop/loading085.svg" :alt="item | itemName">
                </a>
                <button class="btn category-item__quick-view" @click.prevent="openQuickView()">{{
        $translate("Weberbuero::Template.quickView") }}</button>
            </div>

            <div class="category-item__content">

                <div class="category-item__crossselling" v-if="isLoading">
                    <img src="https://bilder.weberbuero.de/frontend/images/shop/loading085.svg" height="34px">
                </div>
                <div class="category-item__crossselling"
                    v-else-if="Array.isArray(crossseller) && crossseller.length > 0">
                    <!-- main variation -->
                    <div class="category-item__crossselling-item d-none d-md-flex">
                        <div class="category-item__img-container" :data-image="thumbForMain.firstImage.urlSecondPreview"
                            @mouseover="loadNewImage(thumbForMain.firstImage.urlSecondPreview, '', '')">
                            <a :href="item | itemURL(false)" :title="item | itemName">
                                <div class="category-item__crossselling-img"
                                    :style="'background-image: url(' + thumbForMain.thumb + ')'"></div>
                            </a>
                        </div>
                    </div>

                    <div class="category-item__crossselling-item d-none d-md-flex"
                        :class="{ 'category-item__crossselling-item--last': key + 1 == 4 }"
                        v-if="crossseller.length > 0" v-for="(cross, key) in crossseller">
                        <div class="category-item__img-container" v-if="key + 1 < 4"
                            :data-image="cross.images.firstImage.urlSecondPreview"
                            @mouseover="loadNewImage(cross.images.firstImage.urlSecondPreview, cross.texts.urlPath, cross.item.id)">
                            <a :href="'/' + cross.texts.urlPath + '/a-' + cross.item.id" :title="cross.texts.name1">
                                <div class="category-item__crossselling-img"
                                    :style="'background-image: url(' + cross.images.thumb + ')'"></div>
                            </a>
                        </div>
                        <div class="category-item__img-container number-indicator d-flex align-items-center justify-content-center"
                            v-else-if="key + 1 == 4">
                            <a :href="item | itemURL(urlWithVariationId)">+ {{ crossseller.length - 3 }}</a>
                        </div>
                    </div>
                    <div class="d-md-none category-item__crossseller-mobile category-item__variations-indicator">
                        <img :src="pluginPath + '/images/icons/configurate_shape.png'" class="category-item__shape">
                        {{ crossseller.length }} {{ $translate('Weberbuero::Template.itemMoreVariations') }}
                    </div>
                </div>
                <div v-else-if="variationsCount > 1" class="category-item__variations-indicator">
                    <div v-if="item.filter.hasChildren">
                        <img :src="pluginPath + '/images/icons/configurate_shape.png'" class="category-item__shape">
                        {{ variationsCount }} {{ $translate('Weberbuero::Template.itemMoreVariations') }}
                    </div>
                    <div v-else>
                        <img :src="pluginPath + '/images/icons/configurate_shape.png'" class="category-item__shape">
                        {{ $translate('Weberbuero::Template.itemMoreVariations') }}
                    </div>
                </div>
                <div v-else>
                    <div class="category-item__crossseller-ws">
                    </div>
                </div>

                <a :href="item | itemURL" class="category-item__itemname">
                    {{ item | itemName }}
                </a>
                <div class="prices">
                    <div class="price">
                        {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted")
                        }}
                    </div>
                    <div v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value"
                        class="price-view-port">
                        <del class="crossprice" v-if="item.prices.specialOffer">
                            {{ item.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                        </del>
                        <del class="crossprice" v-else>
                            {{ item.prices.rrp.unitPrice.formatted | itemCrossPrice }}
                        </del>
                    </div>
                </div>
                <slot name="after-prices"></slot>

                <div class="category-item__availability">
                    {{ item.variation.availability.names.name }}
                </div>
            </div>
        </div>
    </article>

    <article v-else>
        <div class="row">
            <div class="col-4">
                <!--          <div class="category-item__image" v-if="catIdsReverseImage" ref="catImg">&lt;!&ndash; @mouseover="loadThumbs()" @mouseleave="loadThumbs('safari')" &ndash;&gt;-->
                <!--            <a :href="item | itemURL(false)" class="d-block">-->
                <!--              <img :class="'category-item__image-img-0'" :data-src="item.images.all[0].urlSecondPreview" class="img-fluid category-item__image-img lazy-img"-->
                <!--                   src="https://bilder.weberbuero.de/frontend/images/shop/loading085.svg" :alt="item | itemName">-->
                <!--            </a>-->
                <!--            <button class="btn category-item__quick-view" @click.prevent="openQuickView()">{{ $translate("Weberbuero::Template.quickView") }}</button>-->
                <!--          </div>-->
                <div class="category-item__image" ref="catImg">
                    <!-- @mouseover="loadThumbs()" @mouseleave="loadThumbs('safari')" -->
                    <a :href="item | itemURL(false)" class="d-block">
                        <img v-for="(image, index) in (item.images.all).slice(0, 1)"
                            :class="'category-item__image-img-0'" class="img-fluid category-item__image-img"
                            :src="image.urlSecondPreview" :alt="item | itemName">
                    </a>
                    <!--            <button class="btn category-item__quick-view" @click.prevent="openQuickView()">{{ $translate("Weberbuero::Template.quickView") }}</button>-->
                </div>
            </div>

            <div class="col-8">
                <a :href="item | itemURL" class="category-item__itemname">
                    {{ item | itemName }}
                </a>
                <div class="prices">
                    <div class="price">
                        {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted")
                        }}
                    </div>
                    <div v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.price.value"
                        class="price-view-port">

                        <del class="crossprice" v-if="item.prices.specialOffer">
                            {{ item.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                        </del>
                        <del class="crossprice" v-else>
                            {{ item.prices.rrp.unitPrice.formatted | itemCrossPrice }}
                        </del>
                    </div>
                </div>
                <slot name="after-prices"></slot>

                <add-to-basket data-testing="item-add-to-basket" :variation-id="item.variation.id"
                    :is-salable="!!item.filter && item.filter.isSalable"
                    :has-children="!!item.item && item.item.salableVariationCount > 1"
                    :interval-quantity="item.variation.intervalOrderQuantity || 1"
                    :minimum-quantity="item.variation.minimumOrderQuantity"
                    :maximum-quantity="!!item.variation.maximumOrderQuantity && item.variation.maximumOrderQuantity > 0 ? item.variation.maximumOrderQuantity : null"
                    :order-properties="item.properties.filter(function (prop) { return prop.property.isOderProperty })"
                    :has-order-properties="item.hasOrderProperties"
                    :has-required-order-property="item.hasRequiredOrderProperty" :use-large-scale="false"
                    :show-quantity="true" :item-url="item | itemURL(urlWithVariationId)"
                    :has-graduated-price="itemGraduatedPriceisCheapestSorting || itemGraduatedPricesalableVariationCount"
                    :has-price="item | hasItemDefaultPrice" :item-type="item.item.itemType" :is-overlay="isOverlay">
                </add-to-basket>

            </div>
        </div>
    </article>
</template>

<script>
import { mapState } from "vuex";
import CategoryImageCarousel from "./CategoryImageCarousel.vue";
import ItemStoreSpecial from "ceres/app/components/itemList/ItemStoreSpecial.vue";
import { isNullOrUndefined } from "ceres/app/helper/utils";
import { getSlotData } from "ceres/app/helper/getSlotData";

import ApiService from "ceres/app/services/ApiService";
import { Swiper } from 'swiper';

export default
    {
        components:
        {
            CategoryImageCarousel,
            ItemStoreSpecial
        },

        props:
        {
            decimalCount:
            {
                type: Number,
                default: 0
            },

            isOverlay:
            {
                type: Boolean,
                default: false,
            },
            imageUrlAccessor:
            {
                type: String,
                default: "urlMiddle"
            },
            itemData:
            {
                type: Object
            },
            disableCarouselOnMobile:
            {
                type: Boolean
            },
            paddingClasses:
            {
                type: String,
                default: null
            },
            paddingInlineStyles:
            {
                type: String,
                default: null
            },
            forceUrlWithVariationId:
            {
                type: Boolean,
                default: false
            }
        },

        jsonDataFields: [
            "itemDataRef"
        ],

        mounted() {
            this.$nextTick(() => {
                this.initThumbSwiper();
                this.loadFirstImage();
                this.loadItemsIfIPadAndMDLG();
                this.loadCrossseller();
                window.dispatchEvent(new Event('resize'));
            });
        },

        computed:
        {
            images() {
                let img = this.item.images.all
                if (this.item.images.variation && this.item.images.variation.length) {
                    img = this.item.images.variation
                }

                return img
            },

            pluginPath() {
                return App.pluginPath;
            },

            catIdsReverseImage() {
                if (this.currentCategory !== null) {
                    return (App.weberConfig.catIdsReverseImage).split(",").indexOf(this.currentCategory.id) > -1
                }
                return false;
            },

            item() {
                return this.itemData || this.itemSlotData || this.itemDataRef;
            },

            itemSlotData: getSlotData('item-data'),

            storeSpecial() {
                return this.item.item.storeSpecial;
            },

            texts() {
                return this.item.texts;
            },

            itemPrice() {
                return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted");
            },

            itemSetPrice() {
                return this.$options.filters.currency(
                    this.item.prices.default.price.value,
                    this.item.prices.default.currency
                );
            },

            urlWithVariationId() {
                return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0;
            },

            thumbForMain() {
                let firstImage = '';
                let thumb = '';

                for (let innerKey in this.images) {
                    if (this.images[innerKey].position === 0) {
                        firstImage = this.images[innerKey];
                    }
                }

                if (firstImage === '') {
                    firstImage = this.images[0];
                }

                for (let innerKeyProps in this.item.variationProperties) {
                    if (typeof this.item.variationProperties[innerKeyProps].properties !== "undefined") {
                        for (let innerKeyPropsInner in this.item.variationProperties[innerKeyProps].properties) {
                            if (this.item.variationProperties[innerKeyProps].properties[innerKeyPropsInner].id === 10) {
                                thumb = 'https://bilder.weberbuero.de/frontend/images/colors/thumbs/' + this.item.variationProperties[innerKeyProps].properties[innerKeyPropsInner].values.value + '.jpg';
                            }
                        }
                    } else {
                        if (this.item.variationProperties[innerKeyProps].property.id === 10) {
                            thumb = 'https://bilder.weberbuero.de/frontend/images/colors/thumbs/' + this.item.variationProperties[innerKeyProps].values.value + '.jpg';
                        }
                    }
                }

                if (thumb === '') {
                    thumb = firstImage.urlPreview;
                }

                return { firstImage: firstImage, thumb: thumb }
            },

            ...mapState({
                showNetPrices: state => state.basket.showNetPrices,
                currentCategory: state => state.navigation.currentCategory
            })
        },

        data() {
            return {
                loadedImagesForIPad: false,
                crossseller: [],
                variationsCount: 0,
                originalImg: "",
                isLoading: false,
                willLoadNewImage: false,
                newUrl: "",
            }
        },

        methods:
        {
            openQuickView() {
                this.$store.commit("setQuickViewItemId", this.item.item.id);
                this.$store.commit("setQuickViewVariationId", this.item.variation.id);
                this.$store.commit("setQuickViewCrossseller", this.crossseller);
                document.querySelector("body").classList.add("loading-quickview");
            },

            loadNewImage(img, path, id) {



                this.willLoadNewImage = true;
                if (this.originalImg === "") {
                    this.originalImg = this.$refs.catImg.children[0].children[0].src;
                }
                this.$refs.catImg.children[0].children[0].src = img;

                if (path !== "" && id !== "") {
                    this.newUrl = '/' + path + '/a-' + id;
                }
                else {
                    this.newUrl = '';
                }
            },

            loadCrossseller() {

                this.isLoading = true;

                ApiService.get('/rest/weberbuero/crossSellingItems', { id: this.item.item.id, withVarIds: true })
                    .done(response => {

                        for (let itemKey in response.crossseller) {

                            let item = response.crossseller[itemKey].data;

                            if (!isNullOrUndefined(item) && !isNullOrUndefined(item.images)) {

                                let itemImages = item.images.all

                                if (item.images.variation && item.images.variation.length) {
                                    itemImages = item.images.variation
                                }




                                for (let key in itemImages) {
                                    if (itemImages[key].position === 0) {
                                        item.images.firstImage = itemImages[key];
                                    }
                                }

                                if (isNullOrUndefined(item.images.firstImage)) {
                                    item.images.firstImage = itemImages[0];
                                }

                                for (let key in item.variationProperties) {
                                    for (let propKey in item.variationProperties[key].properties) {
                                        if (item.variationProperties[key].properties[propKey].id === 10) {
                                            item.images.thumb = 'https://bilder.weberbuero.de/frontend/images/colors/thumbs/' + item.variationProperties[key].properties[propKey].values.value + '.jpg';
                                        }
                                    }
                                }
                            }

                            if (isNullOrUndefined(item.images.thumb)) {
                                item.images.thumb = item.images.firstImage.urlPreview;
                            }

                            response.crossseller[itemKey] = item;
                        }

                        this.crossseller = response.crossseller;
                        this.variationsCount = response.variationsCount;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log(error)
                    });
            },

            loadThumbs(type) {

                type = type = "";

                if (type === "safari") {
                    if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) && window.matchMedia("(min-width: 768px)").matches && window.matchMedia("(max-width: 1200px)").matches) {
                        $(this.$refs.catImg).find(".category-item__thumbs-img").each(function (index, item) {
                            $(item).attr("src", $(item)[0].dataset.src);
                        });
                        $(this.$refs.catImg).find("img").each(function (index, item) {
                            $(item).attr("src", $(item)[0].dataset.src);
                        });
                        setTimeout(function () {
                            window.dispatchEvent(new Event('resize'));
                        }, 500);
                    }
                } else {
                    if (!this.loadedImagesForIPad) {
                        $(this.$refs.catImg).find(".category-item__thumbs-img").each(function (index, item) {
                            $(item).attr("src", $(item)[0].dataset.src);
                        });
                    }
                    setTimeout(function () {
                        window.dispatchEvent(new Event('resize'));
                    }, 500);
                }

            },

            loadItemsIfIPadAndMDLG() {
                if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) && window.matchMedia("(min-width: 768px)").matches && window.matchMedia("(max-width: 1200px)").matches) {
                    $(this.$refs.catImg).find(".category-item__thumbs-img").each(function (index, item) {
                        $(item).attr("src", $(item)[0].dataset.src);
                    });
                    window.dispatchEvent(new Event('resize'));

                    $(this.$refs.catImg).find("img").each(function (index, item) {
                        $(item).attr("src", $(item)[0].dataset.src);
                    });

                    this.loadedImagesForIPad = true;
                }
            },

            initThumbSwiper() {
                new Swiper(this.$refs.thumbSwiper, {
                    spaceBetween: 5,
                    slidesPerView: 6,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true
                });
            },

            changeMainImage(event) {

                let href = $(event.target)[0].dataset.middleurl;

                $(this.$refs.receivingImgContainer1).attr('src', href);
                $(this.$refs.thumbSwiper).find(".swiper-slide").removeClass('active');
                $(event.target).closest(".swiper-slide").addClass('active');

            },

            loadFirstImage() {

                let lazyImages = [].slice.call($(this.$refs.catImg).find(".lazy-img"));
                let active = false;

                const lazyLoad = function () {
                    if (active === false) {
                        active = true;

                        setTimeout(function () {
                            lazyImages.forEach(function (lazyImage) {

                                if (($(lazyImage).closest(".tab-pane").length > 0 && $(lazyImage).closest(".tab-pane").hasClass("active")) || $(lazyImage).closest(".tab-pane").length == 0) {
                                    if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
                                        lazyImage.src = lazyImage.dataset.src;
                                        lazyImage.classList.remove("lazy-img");

                                        lazyImages = lazyImages.filter(function (image) {
                                            return image !== lazyImage;
                                        });

                                        if (lazyImages.length === 0) {
                                            document.removeEventListener("scroll", lazyLoad);
                                            window.removeEventListener("resize", lazyLoad);
                                            window.removeEventListener("orientationchange", lazyLoad);
                                        }
                                    }
                                }
                            });

                            active = false;
                        }, 200);
                    }
                };

                document.addEventListener("scroll", lazyLoad);
                window.addEventListener("resize", lazyLoad);
                window.addEventListener("orientationchange", lazyLoad);
            }
        }
    }
</script>
